<template>
  <div class="invite-line">
    <div class="user">
      <ShareAvatarBadge :short-name="userName" :size="42" class="avatar" />
      <div class="user-meta">
        <div class="name">
          {{ userName || 'User' }}
          <span v-if="teamName" class="name-tag">({{ teamName }})</span>
        </div>
        <div class="match">Match: <strong>{{ matchText }}</strong></div>
        <div class="code">Invite code. <strong>{{ inviteCode || '--' }}</strong></div>
      </div>
    </div>
    <div class="qr-wrap-container">
      <div class="qr-wrap">
        <div class="qr-wrap-inner">
          <img v-if="qrDataUrl" :src="qrDataUrl" class="qr" alt="qr">
        </div>
        <div class="scan">Scan and join us</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ShareAvatarBadge from './ShareAvatarBadge.vue'

defineProps({
  userName: {
    type: String,
    default: '',
  },
  teamName: {
    type: String,
    default: '',
  },
  matchText: {
    type: String,
    default: '-- vs --',
  },
  inviteCode: {
    type: String,
    default: '',
  },
  qrDataUrl: {
    type: String,
    default: '',
  },
})
</script>

<style scoped lang="less">
.invite-line {
  background: #18212e;
  color: #fff;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 5px 12px;
  min-height: 80px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;

  .user {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
    flex: 1;
  }

  .avatar {
    flex-shrink: 0;
  }

  .user-meta {
    min-width: 0;
  }

  .name {
    font-size: 13px;
    line-height: 16px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .name-tag {
      margin-left: 4px;
      font-size: 12px;
      font-weight: 600;
      color: #dbe3f0;
    }
  }

  .match {
    margin-top: 4px;
    font-size: 10px;
    line-height: 13px;
    color: #dbe3f0;
  }

  .code {
    margin-top: 4px;
    font-size: 10px;
    line-height: 13px;
    color: #dbe3f0;
  }

  .match strong,
  .code strong {
    color: #f9d14a;
  }

  .qr-wrap-container {
    margin-top: -15px;
  }

  .qr-wrap {
    margin-left: 8px;
    text-align: center;
    position: relative;
  }

  .qr-wrap-inner {
    border-radius: 6px;
    padding: 5px;
    background: #18212e;
    position: absolute;
    bottom: -250%;
    left: 0;
  }

  .qr {
    width: 72px;
    height: 72px;
    border-radius: 6px;
    background: #fff;
  }

  .scan {
    margin-top: 4px;
    font-size: 11px;
    line-height: 12px;
    color: #c4ccda;
  }
}
</style>
